var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8.99999C7.0146 8.99999 5.4 7.38539 5.4 5.39998C5.4 3.41458 7.0146 1.79998 9 1.79998C10.9854 1.79998 12.6 3.41458 12.6 5.39998C12.6 7.38539 10.9854 8.99999 9 8.99999ZM12.3822 9.60566C13.0123 9.10078 13.5209 8.46071 13.8702 7.73271C14.2194 7.00471 14.4005 6.20744 14.4 5.39998C14.4007 4.48698 14.1698 3.58876 13.729 2.78919C13.2883 1.98963 12.652 1.31479 11.8796 0.827914C11.1072 0.341043 10.2241 0.0579971 9.31259 0.00514803C8.40111 -0.0477011 7.49111 0.131447 6.66766 0.52579C5.8442 0.920133 5.13418 1.51683 4.60396 2.26009C4.07373 3.00336 3.7406 3.86889 3.63573 4.77585C3.53087 5.68282 3.65767 6.60154 4.0043 7.44619C4.35092 8.29084 4.90606 9.03381 5.6178 9.60566C2.3247 10.8432 0 13.9005 0 18H1.8C1.8 13.5 5.0301 10.8 9 10.8C12.9699 10.8 16.2 13.5 16.2 18H18C18 13.9005 15.6753 10.8432 12.3822 9.60566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.fcaae7316ccb1547a91302744806e6a5.svg";
export { ForwardRef as ReactComponent };